import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import theme from "../../styles/theme";
import {
  CarouselCtaSliceFragment,
  PrismicReusableContent,
  PrismicReusableContentData,
  PrismicReusableContentDataBody,
  PrismicReusableContentDataBodyTextAndLinkCta,
} from "../../types/graphql";
import { IPageContext } from "../../types/types";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { SharedSliceType } from "../shared-slice/shared-slice";
import TextAndLinkCta from "../modules/text-and-link-cta";

export type ICarouselCtaProps = Slice<
  SharedSliceType,
  CarouselCtaSliceFragment["primary"]
> & { type: SharedSliceType.carousel_cta };

const CarouselCta = ({
  slice,
}: SliceComponentProps<ICarouselCtaProps, IPageContext>) => {
  const { primary } = slice;

  const carouselContent = primary?.carousel_slides
    ?.document as PrismicReusableContent;
  const carouselSlides = carouselContent?.data
    ?.body as PrismicReusableContentDataBodyTextAndLinkCta[];

  const document = primary?.carousel_slides?.document as PrismicReusableContent;
  const data = document?.data as PrismicReusableContentData;
  const bodyItems = data?.body as PrismicReusableContentDataBody[];

  const sliderRef = useRef<Slider>(null);
  const [sliderInitialized, setSliderInitialized] = useState(false);
  const settings = {
    arrows: false,
    dots: true,
    fade: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    onInit: () => setSliderInitialized(true),
  };

  return (
    <section className="slice-section theme-light-blue">
      <div className="container">
        <div
          className="relative"
          style={{ paddingBottom: settings.dots ? "25px" : "0" }}
        >
          <Slider
            // className={SliderClass}
            {...settings}
          >
            {bodyItems &&
              bodyItems.map((slide) => {
                if (slide.slice_type === "text_and_link_cta") {
                  const textAndLinkCtaSlice =
                    slide as PrismicReusableContentDataBodyTextAndLinkCta;

                  return (
                    // <div className={data?.content_css_class || ''}>
                    <TextAndLinkCta slice={textAndLinkCtaSlice} />
                    // </div>
                  );
                }
              })}
          </Slider>
        </div>
      </div>
    </section>
  );
};
export default CarouselCta;
